// extracted by mini-css-extract-plugin
export default {"wrapper":"UzyEp5Av1HctZKMrmlWf","titleWrapper":"KyX_QsxjXHKXtddfjASY","titlesContainer":"ethIAxVRxxHPymMvfFQj","actions":"MzvLdA1eOYlAOZDemg1g","newRoleBtn":"xb2oC6PCVm_pqcQ6vvno"};